import {
  SET_AUTOMATED_PAYMENTS_STATE,
  SET_DISABLE_POLLING,
  SET_NOTIFICATIONS_DATA,
  SET_TOOLTIP_TOGGLE,
} from './notificationType';

export const automatedPaymentsDefaultState = {
  showAutomatedPaymentModal: false,
  automatedPayment: null,
  influencerName: null,
  influencerProfileImg: null,
  influencerData: null,
};

const initialState = {
  notifications: [],
  allNotificationsSeen: undefined,
  isTooltipShown: false,
  currentPage: 0,
  unseenCount: 0,
  totalPages: 0,
  loading: false,
  error: null,
  lastMessageId: null,
  automatedPaymentsState: automatedPaymentsDefaultState,
  disablePolling: false,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATIONS_DATA: {
      const { notifications, currentPage, totalPages, append, newMessage, lastMessageId, unseenCount } = action.payload;
      return {
        ...state,
        notifications:
          append === 'firstLoad'
            ? notifications
            : append === 'viewMore'
              ? [...state.notifications, ...notifications]
              : append === 'polling' && unseenCount === 0
                ? [...state.notifications]
                : notifications,
        lastMessageId: lastMessageId || state.lastMessageId,
        currentPage: append === 'polling' && unseenCount > 0 ? 1 : currentPage,
        totalPages,
        loading: false,
        error: null,
        unseenCount,
      };
    }
    case SET_TOOLTIP_TOGGLE:
      return {
        ...state,
        isTooltipShown: action.payload,
      };

    case SET_AUTOMATED_PAYMENTS_STATE:
      return {
        ...state,
        automatedPaymentsState: action.payload,
      };

    case SET_DISABLE_POLLING:
      return {
        ...state,
        disablePolling: action.payload,
      };

    default:
      return state;
  }
};

export default notificationReducer;
